$ = require("jquery");
require("jquery-validation");

$(() => {
  // 数量フィールド名のリスト（フォームに存在するもののみ使用）
  var numberFields = [
    "order[number_serial_100]", "order[number_serial_10]",
    "order[number_fukuren]", "order[number_random_100]", "order[number_random_10]",
    "order[number_3renbara]", "order[number_fukubara]", "order[number_fukubara_1000]",
    "order[number_mini_serial_100]", "order[number_mini_serial_10]",
    "order[number_mini_fukuren]", "order[number_mini_random_100]", "order[number_mini_random_10]",
    "order[number_mini_3renbara]", "order[number_mini_fukubara]", "order[number_mini_fukubara_1000]",
    "order[number_premium_serial_100]", "order[number_premium_serial_10]",
    "order[number_premium_fukuren]", "order[number_premium_random_100]", "order[number_premium_random_10]",
    "order[number_premium_3renbara]", "order[number_premium_fukubara]", "order[number_premium_fukubara_1000]"
  ];

  // フォームに実際に存在するフィールドだけに絞る
  var existingFields = numberFields.filter(function(name) {
    return $("#order_form [name='" + name + "']").length > 0;
  });

  // 存在するフィールドのみルールを生成
  var rules = {};
  existingFields.forEach(function(name) {
    rules[name] = { max_buyable_number: true, min_buyable_number: true };
  });

  // その他の固定ルール
  rules["order[purchase_date_id]"] = { required: true };
  rules["order[booth_no]"] = { required: true };
  rules["order[full_name]"] = { required: true, maxlength: 255 };
  rules["order[full_name_kana]"] = { required: true, katakana: true, maxlength: 255 };
  rules["order[postcode]"] = { required: true, postcode: true };
  rules["order[prefecture_code]"] = { required: true };
  rules["order[address_1]"] = { required: true, maxlength: 255 };
  rules["order[address_2]"] = { required: true, maxlength: 255 };
  rules["order[phone_number]"] = { required: true, phone: true };
  rules["order[email]"] = { required: true, email: true };
  rules["order[comment]"] = { maxlength: 40 };
  rules["order[ship_full_name]"] = { required: function() { return $('#order_ship_to_another_address').prop("checked") }, maxlength: 255 };
  rules["order[ship_full_name_kana]"] = { required: function() { return $('#order_ship_to_another_address').prop("checked") }, katakana: true, maxlength: 255 };
  rules["order[ship_postcode]"] = { required: function() { return $('#order_ship_to_another_address').prop("checked") }, postcode: true };
  rules["order[ship_prefecture_code]"] = { required: function() { return $('#order_ship_to_another_address').prop("checked") } };
  rules["order[ship_address_1]"] = { required: function() { return $('#order_ship_to_another_address').prop("checked") }, maxlength: 255 };
  rules["order[ship_address_2]"] = { required: function() { return $('#order_ship_to_another_address').prop("checked") }, maxlength: 255 };
  rules["order[ship_phone_number]"] = { required: function() { return $('#order_ship_to_another_address').prop("checked") }, phone: true };

  $("#order_form").validate({
    rules: rules,
    groups: {
      group_order_number: existingFields.join(" ")
    },
    errorPlacement: function(error, element) {
      if (element.hasClass("group_order_number")) {
        error.insertAfter("#group_order_number_error");
      }
      else if(element.attr("name")=="order[booth_no]") {
        error.insertAfter("#booth_no_error");
      }
      else if(element.attr("name")=="order[point_used]") {
        error.insertAfter("#point_used_error");
      }
      else {
        error.insertAfter(element);
      }
    },
  });
});

$.extend($.validator.messages, {
  required: "必須です。",
  email: "メールアドレスを入力してください。",
  number: "数字を入力してください。",
  max: "{0}以下の数字を入力してください。",
  min: "{0}以上の数字を入力してください。",
  // require_from_group: '少なくともどれか1つを入力してください。',
});

$.validator.addMethod("postcode", function(value, element) {
  return this.optional( element ) || /^\d{3}-?\d{4}$/.test( value );
}, '郵便番号の形式で入力して下さい。');

$.validator.addMethod("phone", function (value, element) {
  return this.optional(element) || /^0\d{1,4}-?\d{1,4}-?\d{4}$/.test(value);
}, '電話番号の形式で入力して下さい。');

$.validator.addMethod("katakana", function(value, element) {
  return this.optional(element) || /^([ァ-ヶー 　a-zA-Z0-9ａ-ｚＡ-Ｚ０-９]+)$/.test(value);
}, 'カタカナを入力してください。');

var getSelectVal = function(id) {
  var el = $(id);
  return el.length ? Number(el.has("option:selected").val()) : 0;
};

var calcTotalNumber = function() {
  return getSelectVal("#order_number_serial_100") +
    getSelectVal("#order_number_serial_10") +
    getSelectVal("#order_number_fukuren") +
    getSelectVal("#order_number_random_100") +
    getSelectVal("#order_number_random_10") +
    getSelectVal("#order_number_3renbara") +
    getSelectVal("#order_number_fukubara") +
    getSelectVal("#order_number_fukubara_1000") +
    getSelectVal("#order_number_mini_serial_100") +
    getSelectVal("#order_number_mini_serial_10") +
    getSelectVal("#order_number_mini_fukuren") +
    getSelectVal("#order_number_mini_random_100") +
    getSelectVal("#order_number_mini_random_10") +
    getSelectVal("#order_number_mini_3renbara") +
    getSelectVal("#order_number_mini_fukubara") +
    getSelectVal("#order_number_mini_fukubara_1000") +
    getSelectVal("#order_number_premium_serial_100") +
    getSelectVal("#order_number_premium_serial_10") +
    getSelectVal("#order_number_premium_fukuren") +
    getSelectVal("#order_number_premium_random_100") +
    getSelectVal("#order_number_premium_random_10") +
    getSelectVal("#order_number_premium_3renbara") +
    getSelectVal("#order_number_premium_fukubara") +
    getSelectVal("#order_number_premium_fukubara_1000");
};

$.validator.addMethod("max_buyable_number", function(value, element) {
  return this.optional(element) || calcTotalNumber() <= 1000;
}, '1,000枚まで購入可能です。');

$.validator.addMethod("min_buyable_number", function(value, element) {
  return calcTotalNumber() > 0;
}, '少なくともどれか1つを入力してください。');
